
import PaymentStatusWidget from '@/core/components/PaymentStatusWidget.vue';
import { StatusBadgeStatus } from '@/core/enums/status-badge-status';
import { LoanDetails } from '@/loan/types/loan-details';
import { MONTH_MAP } from '@/util/constants/month-map';
import { UtilHelper } from '@/util/helper';
import { Component, Prop, Vue } from 'vue-property-decorator';

const TEST_ID = 'Kloans-LoanOverdueWidget';

@Component({
	components: {
		PaymentStatusWidget,
	},
})
export default class LoanOverdueWidget extends Vue {
	public TEST_ID = TEST_ID;

	public formatDollar = UtilHelper.formatDollar;

	@Prop()
	public loanDetails!: LoanDetails;

	public badgeStatus = StatusBadgeStatus.SUCCESS;

	get daysOverdue(): number {
		return this.loanDetails?.general?.delinquentDays ?? 0;
	}

	get installmentPastDue(): string {
		return this.loanDetails?.general?.installmentPastDue;
	}

	get dueDate(): string {
		const date = new Date(this.loanDetails?.general?.paymentDueDate);
		const dayOfMonth = date.getDate();
		const monthNum = date.getMonth() + 1;
		const month = MONTH_MAP.get(monthNum);

		return `${month} ${dayOfMonth}`;
	}
}
